import { api, BASE } from './client'

export interface CallRoom {
  id: string
  call_type: 'voice' | 'video'
  caller_id: string
  callee_id: string
  status: string
  created_at: string
}

export interface CallRecord {
  id: string
  room_id: string
  caller_id: string
  callee_id: string
  call_type: 'voice' | 'video'
  outcome: 'answered' | 'missed' | 'declined' | 'failed'
  duration_sec: number
  created_at: string
}

export interface TurnCredentials {
  urls: string[]
  username: string
  credential: string
  ttl: number
}

export const callsApi = {
  invite: (calleeId: string, callType: 'voice' | 'video'): Promise<CallRoom> =>
    api.post('/v1/calls/invite', { callee_id: calleeId, call_type: callType }),

  accept: (roomId: string): Promise<void> =>
    api.post(`/v1/calls/${roomId}/accept`),

  reject: (roomId: string, reason = ''): Promise<void> =>
    api.post(`/v1/calls/${roomId}/reject`, { reason }),

  end: (roomId: string): Promise<void> =>
    api.post(`/v1/calls/${roomId}/end`),

  getTurnCredentials: (): Promise<TurnCredentials> =>
    api.get('/v1/calls/turn'),

  getHistory: (limit = 50): Promise<{ records: CallRecord[] }> =>
    api.get(`/v1/calls/history?limit=${limit}`),

  joinGroupCall: (entityId: string): Promise<{ room_id: string; peers: string[] }> =>
    api.post(`/v1/calls/group/${entityId}/join`, {}),

  // Бэкенд резолвит комнату по room_id из тела; передаём полученный при join.
  leaveGroupCall: (roomId: string): Promise<void> =>
    api.post(`/v1/calls/group/${roomId}/leave`, { room_id: roomId }),

  joinConference: (entityId: string): Promise<{ room_id: string; peers: string[] }> =>
    api.post(`/v1/calls/conference/${entityId}/join`, {}),

  startRecording: (roomId: string): Promise<void> =>
    api.post(`/v1/calls/${roomId}/record/start`, {}),

  stopRecording: (roomId: string): Promise<void> =>
    api.post(`/v1/calls/${roomId}/record/stop`, {}),

  getRoom: (roomId: string): Promise<CallRoom> =>
    api.get(`/v1/calls/${roomId}`),

  wsUrl: (): string => {
    const token = localStorage.getItem('access_token') ?? ''
    let wsBase: string
    if (BASE.startsWith('http')) {
      wsBase = BASE.replace(/^http/, 'ws')
    } else {
      const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
      wsBase = `${proto}//${window.location.host}${BASE}`
    }
    return `${wsBase}/v1/calls/ws?token=${token}`
  },
}
